module.exports = __webpack_public_path__ + "fonts/a55d5255-e095-4e87-ac0d-fe0968b0a9c6.6405f352.woff";